import {useEffect, useState} from 'react';

import {useFetchRoundProblemsQuery} from '@goproblems/shared/api/tournaments';
import {TournamentRoundProblem} from '@types';

export const useTournamentRoundProblem = (
    tournamentRoundId?: number | string
) => {
    const {data, refetch} = useFetchRoundProblemsQuery(tournamentRoundId, {
        skip: !tournamentRoundId,
    });

    const [roundProblems, setRoundProblems] = useState<
        TournamentRoundProblem[]
    >([]);

    useEffect(() => {
        if (!data) return;
        setRoundProblems(data);
    }, [data]);

    return {data: roundProblems, refetch, setRoundProblems};
};
